import React, {type ReactElement } from 'react'
import { Link } from '@tanstack/react-router';


export default function HeaderNavMenu():ReactElement {
  return(
    <ul className="nav-menu">
      <li>
        <Link to="/">home</Link>
      </li>
      <li key="1">
        <Link to="/systems">bikes</Link>
      </li>
      <li key="2">
        <Link to="/contact-us">contact us</Link>
      </li>
    </ul>
  )
}
